module.exports = __webpack_public_path__ + "img/12-twoImg.669f1699.png";